import selectNearestDealerPopup from '../../../../modules/dealer-locators/select-nearest-dealer-popup';
import CodeweaversResponse from '../../finance/codeweavers-response';
import Swal from 'sweetalert2';
import { customEvent, generateLeadEvent } from '../../../../modules/tracking/AnalyticsEvents';

export default async function(codeweaversResponse, applicationType) {
    if (applicationType != 'Credit Check' && applicationType != 'Apply') {
        applicationType = 'Apply';
    }

    const locationData = await window.LocationDataLoader.get();
    let filteredLocations = locationData.slice(0);

    filteredLocations = filteredLocations.filter(location => {
        return (location.brand == brand && location.codeweavers_key && location.codeweavers_key != '')
    });
    // If we have a filterDealers object on the page, restrict our available dealers to those
    if (typeof filterDealers !== 'undefined') {
        filteredLocations = filteredLocations.filter(function (location) {
            if (typeof filterDealers[location.id] !== 'undefined') {
                return true;
            }
            return false;
        });
    }

    // const type = codeweaversResponse.financeKeyObject.pseudoKey;

    selectNearestDealerPopup({
        returnFullDealer: true,
        locationData: filteredLocations,
        additionalHtml: (applicationType == 'Apply') ? `<p>Before you can start your finance application, you must first choose your nearest dealer:</p>` : `<p>In order to provide you with your Free Credit Check, you must first choose your nearest dealer:</p>`
    })
    .then(selectedLocation => {
        const financeRequest = codeweaversResponse.financeRequest;

        financeRequest.VehicleRequests[0].Dealer = selectedLocation.codeweavers_key;

        $.ajax({
            async: true,
            type: "POST",
            crossDomain: true,
            dataType: "json",
            url: "https://services.codeweavers.net/public/v2/JsonFinance/Calculate",
            data: financeRequest,
            success: function (data) {
                let applicationURL = '';
                if (applicationType == 'Credit Check') {
                    customEvent('New Vehicle Finance', 'Free Credit Check', 'Complete');
                    applicationURL = 'check';
                    generateLeadEvent('new_finance_cw_credit_check');
                } else {
                    customEvent('New Vehicle Finance', 'Apply For Finance', 'Complete');
                    applicationURL = 'apply';
                    generateLeadEvent('new_finance_cw_apply');
                }

                const newCodeweaversResponse = new CodeweaversResponse(data, financeRequest, codeweaversResponse.vehicleObject, codeweaversResponse.financeKeyObject);
                let quote = newCodeweaversResponse.getFinanceProductOfInterest(codeweaversResponse.financeKeyObject);
                if (quote == false) {
                    Swal.fire(
                        'Something went wrong',
                        'We\'re sorry, but our system has been unable to generate a quote at this time. Please contact your nearest dealer to discuss a personal quotation.',
                        'error'
                    );
                    return false;
                }

                window.location = quote.getLink() + '/' + applicationURL;
                return false;
            }
        });
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-cta.js